import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import './translation/index'
import { Provider } from 'react-redux'
import ErrorBoundary from 'components/ui-kit/ErrorBoundary/index'
import store from 'redux-store/store'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import { FullscreenProvider } from 'hook/useFullScreen'
import { IntlProvider } from 'react-intl'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <ToastContainer
          position='top-right'
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme='colored'
          style={{ zIndex: 99999 }}
        />
        {/* <FullscreenProvider> */}
        <IntlProvider locale='en'>
          <App />
        </IntlProvider>
        {/* </FullscreenProvider> */}
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

export default store
